import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import AntdSlider from 'antd/lib/slider';

const SliderWrapper = styled.div`
  width: 100%;
`;

const SliderLabel = styled.div`
  opacity: 0.5;
  margin: 10px 0 -5px;
`;

const SliderComponent = styled(AntdSlider)`
  .ant-slider-track {
    background-color: ${({ theme }) => theme.less.primaryColor};
  }
  .ant-slider-handle, .ant-slider-dot-active {
    border-color: ${({ theme }) => theme.less.primaryColor} !important;
  }
`;

const Slider = ({
  label,
  value,
  onChange,
}) => {
  value = useMemo(
    () => value || [1, 5],
    [value],
  );
  const [tempValue, setTempValue] = useState(value);
  useEffect(
    () => { setTempValue(value); },
    [value],
  );
  return (
    <SliderWrapper>
      <SliderLabel>
        {label}
      </SliderLabel>
      <SliderComponent
        tipFormatter={tipValue => (tipValue)}
        range
        min={1}
        max={5}
        step={1}
        marks={{
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        }}
        value={tempValue}
        onChange={setTempValue}
        onAfterChange={newValue => onChange(newValue.join(','))}
      />
    </SliderWrapper>
  )
};

export default Slider;
